// Core
import { NavigationGuard } from "vue-router";
import { until } from "@vueuse/core";

// Stores
import pinia from "@/store/pinia";

// Stores
import { useUserStore } from "@/store/user";
import { useTeamStore } from "@/store/team";

const requireOnboarding: NavigationGuard = async (_, __, next) => {
  try {
    const userStore = useUserStore(pinia);
    const teamStore = useTeamStore(pinia);

    // Aguarda o carregamento dos dados do team store se estiver carregando
    if (teamStore.loading) {
      await until(() => teamStore.loading).toBe(false);
    }

    const infos = userStore.userInfos;

    if (teamStore.teamIsLeadMachineOnly) return next();

    const onboarding = infos?.onboarding;
    const completed = onboarding?.hasCompleted || onboarding?.hasCompletedStep2;

    if (completed) return next();

    const step = onboarding?.currentStep;

    const pendingInvites = teamStore.pendingInvites || [];
    const pendingInvite = pendingInvites.length;

    if (pendingInvite) return next("/sign-up");

    if (step === 6 || step === 5) {
      // Check if user (invited or not) has a valid subscription
      if (teamStore.hasValidSubscription && !teamStore.isSubscriptionLate) {
        // Mark onboarding as completed for users with valid subscription
        await userStore.updateUser({ 
          onboarding: { hasCompleted: true }
        });
        return next();
      }
      return next("subscription");
    }

    return next("sign-up");
  } catch (error) {
    next({ name: "500" });
  }
};

export default requireOnboarding;
